(function () {
  'use strict';

  if (window.__voroPdpChapter) return;
  window.__voroPdpChapter = true;

  var DESKTOP = '(min-width: 960px)';
  var REDUCED = '(prefers-reduced-motion: reduce)';

  function setup(section) {
    var beats = [].slice.call(section.querySelectorAll('.vpdp__beat'));
    var shots = [].slice.call(section.querySelectorAll('.vpdp__chapter-shot'));
    if (beats.length < 2 || !shots.length) return;

    var active = -1;

    function lift(i) {
      for (var n = 0; n < shots.length; n++) {
        shots[n].style.willChange = (n === i || n === active) ? 'opacity, transform' : '';
      }
    }

    function show(i) {
      if (i === active) return;
      lift(i);
      active = i;
      for (var n = 0; n < shots.length; n++) shots[n].classList.toggle('is-on', n === i);
      for (var b = 0; b < beats.length; b++) beats[b].classList.toggle('is-on', b === i);

      var vid = shots[i].querySelector('[data-chapter-vid]');
      if (vid) {
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      }
      for (var v = 0; v < shots.length; v++) {
        if (v === i) continue;
        var other = shots[v].querySelector('[data-chapter-vid]');
        if (other && !other.paused) { try { other.pause(); } catch (e) {} }
      }
    }

    var io = new IntersectionObserver(function (entries) {
      var best = null;
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        if (!best || entries[i].intersectionRatio > best.intersectionRatio) best = entries[i];
      }
      if (!best) return;
      var idx = parseInt(best.target.getAttribute('data-beat'), 10);
      if (!isNaN(idx)) show(idx);
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    beats.forEach(function (b) { io.observe(b); });

    section.classList.add('is-pinned');
    section.querySelector('.vpdp__chapter-media').removeAttribute('aria-hidden');

    active = 0;
    shots[0].classList.add('is-on');
    beats[0].classList.add('is-on');
    lift(0);

    return function teardown() {
      io.disconnect();
      shots.forEach(function (sh) {
        var v = sh.querySelector('[data-chapter-vid]');
        if (v && !v.paused) { try { v.pause(); } catch (e) {} }
        sh.style.willChange = '';
      });
      section.classList.remove('is-pinned');
      var media = section.querySelector('.vpdp__chapter-media');
      if (media) media.setAttribute('aria-hidden', 'true');
      beats.forEach(function (b) { b.classList.remove('is-on'); });
      shots.forEach(function (s, n) { s.classList.toggle('is-on', n === 0); });
      active = -1;
    };
  }

  function init() {
    if (!('IntersectionObserver' in window) || !window.matchMedia) return;
    var wide = window.matchMedia(DESKTOP);
    var calm = window.matchMedia(REDUCED);

    [].slice.call(document.querySelectorAll('[data-vpdp-chapter]')).forEach(function (section) {
      if (section.getAttribute('data-chapter-bound') === '1') return;
      section.setAttribute('data-chapter-bound', '1');

      var teardown = null;
      function apply() {
        var wants = wide.matches && !calm.matches;
        if (wants && !teardown) teardown = setup(section) || null;
        else if (!wants && teardown) { teardown(); teardown = null; }
      }
      apply();

      [wide, calm].forEach(function (mq) {
        if (mq.addEventListener) mq.addEventListener('change', apply);
        else if (mq.addListener) mq.addListener(apply);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
